import React from 'react';
import Icon from '../AppIcon';

const NewUserCard = ({ user, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full bg-card rounded-2xl border border-border overflow-hidden shadow-gaming-md transition-gaming hover:shadow-gaming-lg active:translate-y-px active:shadow-gaming-md"
      aria-label={user?.username ? `${user.username} 프로필 보기` : '유저 프로필 보기'}
    >
      <div className="relative">
        <div className="aspect-[3/2] bg-gradient-to-br from-primary/20 via-muted/10 to-accent/10">
          {user?.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt={user.username}
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <Icon name="User" size={56} className="text-muted-foreground" />
            </div>
          )}
        </div>
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <div className="px-2.5 py-1 rounded-full bg-background/80 border border-border text-xs font-bold text-foreground backdrop-blur">
            Lv.{Number(user?.level || 1)}
          </div>
          <div className="px-2.5 py-1 rounded-full bg-background/80 border border-border text-xs font-semibold text-muted-foreground backdrop-blur">
            NEW
          </div>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="text-lg font-heading font-bold text-foreground truncate drop-shadow">
            {user?.username}
          </div>
          <div className="mt-1 w-full h-2 bg-background/60 rounded-full overflow-hidden border border-border">
            <div
              className="h-full bg-primary"
              style={{ width: `${Math.min(100, Number(user?.levelProgress || 0))}%` }}
            />
          </div>
        </div>
      </div>

      <div className="p-4">
        <div className="grid grid-cols-2 gap-2">
          <div className="rounded-xl border border-border bg-muted/30 p-3 text-left">
            <div className="text-[11px] text-muted-foreground caption">출석일수</div>
            <div className="text-base font-bold text-foreground data-text">{Number(user?.attendanceDays || 0).toLocaleString('ko-KR')}</div>
          </div>
          <div className="rounded-xl border border-border bg-muted/30 p-3 text-left">
            <div className="text-[11px] text-muted-foreground caption">등록 목표</div>
            <div className="text-base font-bold text-foreground data-text">{Number(user?.totalProjects || 0).toLocaleString('ko-KR')}</div>
          </div>
          <div className="rounded-xl border border-border bg-muted/30 p-3 text-left">
            <div className="text-[11px] text-muted-foreground caption">완료 챌린지</div>
            <div className="text-base font-bold text-foreground data-text">{Number(user?.completedChallenges || 0).toLocaleString('ko-KR')}</div>
          </div>
          <div className="rounded-xl border border-border bg-muted/30 p-3 text-left">
            <div className="text-[11px] text-muted-foreground caption">제출한 증명</div>
            <div className="text-base font-bold text-foreground data-text">{Number(user?.submittedProofs || 0).toLocaleString('ko-KR')}</div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default NewUserCard;
